import { render, staticRenderFns } from "./redesView.vue?vue&type=template&id=d978e94a&scoped=true"
import script from "./redesView.vue?vue&type=script&lang=js"
export * from "./redesView.vue?vue&type=script&lang=js"
import style0 from "./redesView.vue?vue&type=style&index=0&id=d978e94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d978e94a",
  null
  
)

export default component.exports